<template>
	<div class="text-center text-gray-500 flex-1 flex justify-center flex-col">
		<div class="text-xl font-semibold">Server Error</div>
		<div class="text-lg">We will be back, as soon as possible</div>
	</div>
</template>

<script>
export default {
    name: "ServerError"
};
</script>
